import React, { useCallback, useMemo } from 'react';
import ClassRosterCard from '../../components/chat/batch/ClassRosterCard';

// 채점 전 확인 목록 위에서 '우리 반' 명단과 이름을 맞춘다. 고른 이름만 onRename(key, name)으로 돌려준다.
const ScoringRosterMatch = ({ items = [], onRename }) => {
  const students = useMemo(() => items.map(item => ({ id: item.key, name: item.name || '' })), [items]);
  const resetKey = useMemo(() => items.map(item => item.key).join('|'), [items]);
  const handleApply = useCallback((updates) => {
    updates.forEach((update) => {
      if (update.name) onRename?.(update.key, update.name);
    });
  }, [onRename]);

  if (items.length < 2) return null;
  return (
    <div className="scoring-roster-match">
      <ClassRosterCard
        key={resetKey}
        students={students}
        createdFrom="scoring"
        onApply={handleApply}
      />
    </div>
  );
};

export default ScoringRosterMatch;
